module.exports = __webpack_public_path__ + "media/images/manager/no_image-a7001ee8213e668bebec5372cfd309f1.png";